// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
    .phone-input { display: flex; gap: .5rem; width: 100%; }
    .phone-dial { flex: 0 0 8.5rem; }
    .phone-number { flex: 1; min-width: 0; }
  `, "",{"version":3,"sources":["webpack://./src/app/components/phone-input/phone-input.component.ts"],"names":[],"mappings":";IACI,eAAe,aAAa,EAAE,UAAU,EAAE,WAAW,EAAE;IACvD,cAAc,gBAAgB,EAAE;IAChC,gBAAgB,OAAO,EAAE,YAAY,EAAE","sourcesContent":["\n    .phone-input { display: flex; gap: .5rem; width: 100%; }\n    .phone-dial { flex: 0 0 8.5rem; }\n    .phone-number { flex: 1; min-width: 0; }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
